import { useEffect } from 'react';
import './App.scss';
import WebFont from 'webfontloader';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Catalog from "./pages/Catalog";
import Home from "./pages/Home";
import Detail from "./pages/detail/Detail";
import 'swiper/swiper.min.css';
import './assets/boxicons-2.0.7/css/boxicons.min.css';
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

function App() {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Poppins", "Montserrat"]
      }
    });
  }, []);
  return (
    <BrowserRouter>
      <div>
        <Header />
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/:category/search/:keyword' element={<Catalog />} />
          <Route exact path='/:category/:id' element={<Detail />} />          
          <Route exact path='/:category' element={<Catalog />} />          
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
